<template>
  <i class="iconify mingcute--left-line" />
</template>
